import { type MouseEvent, useCallback, useState } from "react";
import { Button } from "@/components/ui/button";
import { StripePricingTableDialog } from "../StripePricingTableDialog";
import { socialLinks, termsFooter } from "./const";

export const MarketsFooter = () => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handlePricingButtonClick = useCallback((e: MouseEvent) => {
		e.preventDefault();
		setIsDialogOpen(true);
	}, []);

	return (
		<div
			className="flex flex-col items-center justify-center pt-10 pb-2"
			data-testid="markets-footer"
		>
			<p className="my-2 mx-8 text-[#7f7f7f] text-xxs">{termsFooter}</p>

			<div className="flex flex-row flex-wrap justify-center gap-4">
				{socialLinks.map((link) => (
					<a
						key={link.src}
						href={link.href}
						target="_blank"
						rel="noopener noreferrer"
						className="flex items-center justify-center rounded-full"
					>
						<img
							src={link.src}
							alt={link.alt}
							className="rounded-full w-8 h-8"
						/>
					</a>
				))}
			</div>
			<div className="flex flex-row flex-wrap	justify-center gap-4 my-4">
				<a
					href="https://epsmomentum.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					Home
				</a>
				<a href="/dashboard" target="_blank" rel="noopener noreferrer">
					Dashboard
				</a>
				<a
					href="mailto:support@epsmomentum.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					Support
				</a>

				<Button
					variant="link"
					onClick={handlePricingButtonClick}
					className="no-underline text-accent-foreground"
				>
					Subscribe
				</Button>
				<a
					href="https://epsmomentum.com/terms-conditions"
					target="_blank"
					rel="noopener noreferrer"
				>
					Legal
				</a>
			</div>
			<p>Made in New York City.</p>
			<p>All Rights reserved EPSM Inc, {new Date().getFullYear()}</p>
			<p>
				EPSM Inc, 205 East 42<sup>nd</sup> Street, New York City, NY, USA
			</p>
			<p>
				Contact us at{" "}
				<a href="mailto:support@epsmomentum.com">support@epsmomentum.com</a>
			</p>

			{isDialogOpen && (
				<StripePricingTableDialog
					open={isDialogOpen}
					onOpenChange={setIsDialogOpen}
				/>
			)}
		</div>
	);
};
